import { render, staticRenderFns } from "./journey-report.vue?vue&type=template&id=01a15d36&"
import script from "./journey-report.vue.js?vue&type=script&lang=js&"
export * from "./journey-report.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports